module.exports = __webpack_public_path__ + "img/points_colour.f23361da.png";